module.exports = __webpack_public_path__ + "img/sachsen.07cb598.webp";